<template>
  <section class="playlists">
    <div class="playlists__container">
      <h2 class="playlists__header-title">Playlists</h2>
      <h4 class="playlists__header-subtitle">Assigned to you</h4>
      <div class="playlists__section-wrapper">
        <ActionLoader
          v-if="!playlists.length"
          :size="1"
          class="playlists__loader"
        />
        <Playlist
          v-for="playlist of playlists"
          :key="playlist.id"
          :playlist="playlist"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Playlist from '@/components/playlists/Playlist.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'Playlists',
  components: {
    Playlist,
    ActionLoader,
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
    }),
    ...mapGetters('playlists', ['playlists']),
  },
  methods: {
    ...mapActions('playlists', ['getPlaylists']),
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.getPlaylists()
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.playlists {
  display: flex;
  justify-content: center;
  background-image: url('../assets/images/backgrounds/dashboard_bg.jpg');
  background-size: cover;
  color: var(--white);
  min-height: 100vh;
  padding: 110px 20px 20px 20px;

  @include tablet {
    padding: 80px 20px 20px 20px;
  }
  @include desktop {
    padding: 125px 100px 100px 100px;
  }
  &__container {
    flex: 1;
    max-width: 1600px;
  }

  &__header-title {
    font-family: var(--font-bold);
    font-size: rem(40px);
    line-height: rem(52px);
    margin: 0px;

    @include tablet {
      font-size: rem(32px);
      line-height: rem(38px);
    }
    @include desktop {
      font-size: rem(40px);
      line-height: rem(52px);
    }
  }
  &__header-subtitle {
    font-size: rem(18px);
    line-height: rem(24px);
    margin: 10px 0px 0px 0px;

    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 20px;
    }
  }
  &__section-wrapper {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }
  &__loader {
    display: flex;
    justify-content: center;
  }
}
</style>
